import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  wrapper: {
    border: "1px solid ".concat(palette.shades[300]),
    padding: '60px',
    textAlign: 'center',
    marginTop: '20px'
  }
});
export default useStyles;